import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9e6d8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "При обработке файла импорта обнаружены направления, которые невозможно импортировать.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ExcelModal__text" }, " Для закрепления дочерних направлений, отмеченных галочкой, нажмите “Подтвердить”, либо внесите изменения в файл / систему и повторите попытку: ", -1))
const _hoisted_3 = { class: "w-full border-collapse" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Дочернее направление"),
    /*#__PURE__*/_createElementVNode("th", null, "Результат импорта")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-times"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "Internal__text" }
const _hoisted_10 = {
  class: "Internal__download",
  href: "/Шаблон_для_дочерних_направлений.xlsx",
  download: "Шаблон_для_дочерних_направлений.xlsx"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "LinkText" }, " Скачать шаблон импорта ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Перетащите файл в это окно или", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Internal__upload" }, "выберите его на вашем устройстве", -1))
const _hoisted_14 = {
  key: 0,
  class: "Internal__files"
}
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = { class: "text-gray-800 font-medium truncate" }
const _hoisted_17 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_export_icon = _resolveComponent("export-icon")!
  const _component_upload_icon = _resolveComponent("upload-icon")!
  const _component_excel_icon = _resolveComponent("excel-icon")!
  const _component_times_grey_icon = _resolveComponent("times-grey-icon")!

  return (_ctx.state.excel_response.length)
    ? (_openBlock(), _createBlock(_component_new_modal, {
        key: 0,
        title: "Обработка файла импорта",
        loading: _ctx.loading || _ctx.state.is_loading,
        class: "ExcelModal",
        "with-cancel-button": "",
        onSubmit: _ctx.onSubmitExcel,
        onCancel: _ctx.cancelExcel
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.excel_response, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `excelRow-${index}`,
                  class: _normalizeClass(item.isSuccess ? 'bg-green-100' : 'bg-red-100')
                }, [
                  _createElementVNode("td", null, [
                    (item.isSuccess)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                      : (_openBlock(), _createElementBlock("i", _hoisted_6))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.fromCityName) + " - " + _toDisplayString(item.whereCityName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.reason), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading", "onSubmit", "onCancel"]))
    : (_openBlock(), _createBlock(_component_new_modal, {
        key: 1,
        title: "Импорт дочерних направлений",
        loading: _ctx.loading,
        onSubmit: _ctx.importExcel,
        onCancel: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_loader, { class: "primary" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, " Загрузите файл со списком дочерних направлений для закрепления их за родителем " + _toDisplayString(_ctx.direction) + ". ", 1),
                _createElementVNode("a", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_export_icon, { class: "ml-2" })
                ]),
                _createElementVNode("div", {
                  class: "Internal__draggable",
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
                  onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isDragging = false), ["prevent"])),
                  onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", {
                    for: "fileInput",
                    class: _normalizeClass(["Internal__field", {
                        'border-blue-400 text-blue-500 bg-blue-50': _ctx.isDragging,
                        'border-gray-300 text-gray-500': !_ctx.isDragging,
                    }])
                  }, [
                    _createVNode(_component_upload_icon, { class: "Internal__cloud" }),
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("input", {
                      id: "fileInput",
                      type: "file",
                      class: "hidden",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFile && _ctx.handleFile(...args)))
                    }, null, 32)
                  ], 2)
                ], 32),
                (_ctx.file)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_excel_icon, { class: "mr-2" }),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.file.name), 1),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.formatSize(_ctx.file.size)), 1)
                      ]),
                      _createVNode(_component_times_grey_icon, {
                        class: "Internal__delete",
                        onClick: _ctx.removeFile
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["loading", "onSubmit", "onCancel"]))
}